import {useMemo} from 'preact/hooks';

import type {Experiments} from '~/types/init';
import type {UxModeType} from '~/types/uxMode';
import {isMobileWebview} from '~/utils/browser';

interface Props {
  experiments?: string;
  uxMode: UxModeType;
  defaultUxMode: UxModeType;
}

export const useAdjustedUxMode = ({
  defaultUxMode,
  experiments,
  uxMode,
}: Props) => {
  const adjustedUxMode = useMemo(() => {
    // If the AA experiment (https://experiments.shopify.com/experiments/shop_account_sfr_assignment_validation)
    // is enabled we will always return false for the windoid condition. this is done to be able to analyze
    // the exp integrity without consequences to the end user
    const mobileWebView = isMobileWebview();

    const parsedExperiment = (() => {
      try {
        return experiments ? JSON.parse(experiments) : {};
      } catch (err) {
        return {};
      }
    })() as Experiments;

    if (parsedExperiment.windoidExperimentVariant) {
      return 'iframe';
    }

    const shouldUseDefault = uxMode === 'windoid' && mobileWebView;

    return shouldUseDefault ? defaultUxMode : uxMode;
  }, [experiments, defaultUxMode, uxMode]);
  return adjustedUxMode;
};
